import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  Collapse,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import * as React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

type SubMenuProps = {
  label: string;
  icon?: React.ReactNode;
  matchPaths?: string[];
  defaultOpen?: boolean;
  to?: string;
  children: React.ReactNode;
};

export function SubMenu({
  label,
  icon,
  matchPaths = [],
  defaultOpen = false,
  to,
  children,
}: SubMenuProps) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const autoOpen = matchPaths.some((p) => pathname.startsWith(p));
  const [open, setOpen] = React.useState(defaultOpen || autoOpen);

  React.useEffect(() => {
    if (autoOpen) setOpen(true);
  }, [autoOpen]);

  const onHeaderClick = async () => {
    if (to) await navigate(to);
    else setOpen((o) => !o);
  };

  return (
    <>
      <ListItemButton onClick={onHeaderClick}>
        {icon ? (
          <ListItemIcon sx={{ minWidth: 40, color: 'secondary.main' }}>{icon}</ListItemIcon>
        ) : null}
        <ListItemText primary={label} />
        <IconButton
          size='small'
          edge='end'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen((o) => !o);
          }}
        >
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </ListItemButton>

      <Collapse
        in={open} timeout='auto'
        unmountOnExit
      >
        <List dense disablePadding>
          {children}
        </List>
      </Collapse>
    </>
  );
}

type SubMenuItemProps = {
  to: string;
  primaryText: string;
  icon?: React.ReactNode;
};

export function SubMenuItem({ to, primaryText, icon }: SubMenuItemProps) {
  return (
    <ListItemButton
      component={NavLink} to={to}
      sx={{ paddingLeft: 3 }}
    >
      {icon ? <ListItemIcon sx={{ minWidth: 40, color: 'secondary.main' }}>{icon}</ListItemIcon> : null}
      <ListItemText primary={primaryText} />
    </ListItemButton>
  );
}
